// extracted by mini-css-extract-plugin
export default {"container":"objectViewer_container__nionu","object_collapse":"objectViewer_object_collapse__64Wf-"};